import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports
import { Menu, Sidebar, SidebarProps } from 'semantic-ui-react';

import { useOrganization } from '../../hooks/useOrganizations';

// Import components.
import LeftNavigation from './LeftNavigation';

// Default navy side nav uses the white Wonderschool logo. The Florida (FDOE)
// network keeps its original light theme and FDOE logo (see _navigation.scss).
import whiteLogo from '../../assets/images/svg/white-primary-logo.svg?url';
import fdoeLogo from '../../assets/images/wonderschool/FDOE_Logo.png';

import WSA from '../../WSA';

const FLORIDA_ID = import.meta.env.VITE_FLORIDA_NETWORK_ID;

interface DesktopNavigationProps {
  viewport?: string;
  animation?: SidebarProps['animation'];
  direction?: SidebarProps['direction'];
  visible: boolean;
  sidebarWidth: number;
}

function DesktopNavigation({ viewport, animation, direction, visible, sidebarWidth, ...rest }: DesktopNavigationProps) {
  const location = useLocation();
  const { pathname } = location;
  const { isReady, isAuthenticated } = WSA.Components.useWSAuth();

  const organization = useOrganization();

  // Florida (FDOE) keeps its original branding; every other network gets the
  // navy nav with the white Wonderschool logo.
  const isFlorida = Boolean(organization?.networks?.includes(FLORIDA_ID));
  const logo = isFlorida ? fdoeLogo : whiteLogo;

  // Remove/hide navbar on invoice pages.
  if (
    pathname?.startsWith('/invoice/') ||
    !(isReady && isAuthenticated) // user is logged in but the org is still loading
  )
    return null;

  return (
    <Sidebar
      id="main-menu"
      as={Menu}
      vertical
      size="large"
      animation="uncover"
      direction="left"
      visible={visible}
      borderless
      className={isFlorida ? 'network-florida' : undefined}
      data-testid="main-menu"
      {...rest}
    >
      <div className={`position: absolute; width: ${sidebarWidth}px`}>
        {/* paddingLeft matches the nav items' icon column (~20px) so the logo lines up with them;
            extra paddingBottom adds breathing room between the logo and the first nav item */}
        <Menu.Item style={{ paddingTop: '1.2rem', paddingBottom: '2.25rem', paddingLeft: '20px' }}>
          <img src={logo} alt="Wonderschool logo" className="w-[65%]" data-testid="logo" />
        </Menu.Item>
        <LeftNavigation />
      </div>
    </Sidebar>
  );
}

const mapStateToProps = (_state) => ({
  //
});

export default connect(mapStateToProps, {})(DesktopNavigation);
